module.exports = __webpack_public_path__ + "img/22.8.TSS.2024b950.png";